import { render, staticRenderFns } from "./DoctorReportLoreal.vue?vue&type=template&id=db46a602&scoped=true"
import script from "./DoctorReportLoreal.vue?vue&type=script&lang=ts"
export * from "./DoctorReportLoreal.vue?vue&type=script&lang=ts"
import style0 from "./DoctorReportLoreal.vue?vue&type=style&index=0&id=db46a602&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db46a602",
  null
  
)

export default component.exports